import React from 'react';

/**
 * Unified feature panel with sub-title (eyebrow), title, description, and footer.
 */
function FeaturePanel({ subTitle, title, description, footer, styles, footerStyle }) {
  const footerContainerStyle = footerStyle ? { ...styles.featureActions, ...footerStyle } : styles.featureActions;
  return (
    <>
      <p style={styles.featureEyebrow}>{subTitle}</p>
      <h3 style={styles.featureTitle}>{title}</h3>
      <p style={styles.featureText}>{description}</p>
      <div style={footerContainerStyle}>{footer}</div>
    </>
  );
}

export default FeaturePanel;
